type Digit = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';

export type Hour = `0${Digit}` | `1${Digit}` | '20' | '21' | '22' | '23';
export type Minute = `${'0' | '1' | '2' | '3' | '4' | '5'}${Digit}`;

export type TimeType = `${Hour}:${Minute}`;

const TIME_TYPE_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;

export function isTimeType(value: string): value is TimeType {
  return TIME_TYPE_REGEX.test(value);
}
